// extracted by mini-css-extract-plugin
export default {"pinkShade":"svg_pinkShade__-IV7i","clickOpenSvg":"svg_clickOpenSvg__pByDO","timelinesvg":"svg_timelinesvg__B2wpT"};